const initialData_in = [
    {name: "paraCd", type: "text", value: "", readOnly: true,cmptCheck:false, cmptType:""},
    {name: "paraNm", type: "select", value: "", options: "main",cmptCheck:false, cmptType:""},
    {name: "paraDesc", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "unit", type: "select", value: "", options: "unit",cmptCheck:false, cmptType:""},
    {name: "rcvCritical", type: "select", value: "", options: "critical",cmptCheck:false, cmptType:""},
    {name: "rcvSetpoint", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvTarMinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvTarMin", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvTarMaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvTarMax", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvAccMinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvAccMin", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "rcvAccMaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "rcvAccMax", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndCritical", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndSetpoint", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndTarMinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndTarMin", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndTarMaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndTarMax", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndAcc1MinSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndAcc1Min", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "sndAcc1MaxSign", type: "select", value: "", options: "sign",cmptCheck:false, cmptType:""},
    {name: "sndAcc1Max", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "reference", type: "text", value: "",cmptCheck:false, cmptType:""},
    {name: "remark", type: "checkbox", value: "FALSE",cmptCheck:false, cmptType:""},
    {name: "hide", type: "checkbox", value: "FALSE",cmptCheck:false, cmptType:""},
    {name: "uniqueCode", type: "hidden", value : "", type2: "hidden"}
];

const initialData_out = [
    {name: "paraCd", type: "text", value: "", readOnly: true},
    {name: "testItem", type: "select", value: "", options: "main"},
    {name: "samplePoint", type: "select", value: "", options: "sample", label: ""},
    {name: "dayCycle", type: "text", value: ""},
    {name: "paraNm", type: "text", value: ""},
    {name: "sopNo", type: "text", value: ""},
    {name: "unit", type: "select", value: "", options: "unit"},
    {name: "rcvCritical", type: "select", value: "", options: "critical"},
    {name: "rcvTarMinSign", type: "select", value: "", options: "sign"},
    {name: "rcvTarMin", type: "text", value: ""},
    {name: "rcvTarMaxSign", type: "select", value: "", options: "sign"},
    {name: "rcvTarMax", type: "text", value: ""},
    {name: "rcvAccMinSign", type: "select", value: "", options: "sign"},
    {name: "rcvAccMin", type: "text", value: ""},
    {name: "rcvAccMaxSign", type: "select", value: "", options: "sign"},
    {name: "rcvAccMax", type: "text", value: ""},
    {name: "sndCritical", type: "text", value: ""},
    {name: "sndTarMinSign", type: "select", value: "", options: "sign"},
    {name: "sndTarMin", type: "text", value: ""},
    {name: "sndTarMaxSign", type: "select", value: "", options: "sign"},
    {name: "sndTarMax", type: "text", value: ""},
    {name: "sndAcc1MinSign", type: "select", value: "", options: "sign"},
    {name: "sndAcc1Min", type: "text", value: ""},
    {name: "sndAcc1MaxSign", type: "select", value: "", options: "sign"},
    {name: "sndAcc1Max", type: "text", value: ""},
    {name: "reference", type: "text", value: ""},
    {name: "remark", type: "checkbox", value: "FALSE"},
    {name: "hide", type: "checkbox", value: "FALSE"},
    {name: "uniqueCode", type: "hidden", value : "", type2: "hidden"}
];

const initialData_qc = [
    {name: "paraCd", type: "text", value: ""},
    {name: "samplePoint", type: "select", value: "", options: "sample", label: ""},
    {name: "dayCycle", type: "text", value: ""},
    {name: "paraNm", type: "text", value: ""},
	{name: "testMethod", type: "text", value: ""},
    {name: "unit", type: "text", value: ""},
	{name: "rcvCritical", type: "select", value: "", options: "critical"},
    {name: "rcvAlrMinSign", type: "select", value: "", options: "sign"},
    {name: "rcvAlrMin", type: "text", value: ""},
    {name: "rcvAlrMaxSign", type: "select", value: "", options: "sign"},
    {name: "rcvAlrMax", type: "text", value: ""},
    {name: "rcvActMinSign", type: "select", value: "", options: "sign"},
    {name: "rcvActMin", type: "text", value: ""},
    {name: "rcvActMaxSign", type: "select", value: "", options: "sign"},
    {name: "rcvActMax", type: "text", value: ""},
    {name: "rcvAccSign", type: "select", value: "", options: "sign"},
	{name: "rcvAcc", type: "text", value: ""},
    {name: "sndCritical", type: "text", value: ""},
    {name: "sndAlrMinSign", type: "select", value: "", options: "sign"},
    {name: "sndAlrMin", type: "text", value: ""},
    {name: "sndAlrMaxSign", type: "select", value: "", options: "sign"},
    {name: "sndAlrMax", type: "text", value: ""},
    {name: "sndAct1MinSign", type: "select", value: "", options: "sign"},
    {name: "sndAct1Min", type: "text", value: ""},
    {name: "sndAct1MaxSign", type: "select", value: "", options: "sign"},
    {name: "sndAct1Max", type: "text", value: ""},
    {name: "sndAccSign", type: "select", value: "", options: "sign"},
	{name: "sndAcc", type: "text", value: ""},
    {name: "reference", type: "text", value: ""},
    {name: "remark", type: "checkbox", value: "FALSE"},
    {name: "hide", type: "checkbox", value: "FALSE"},
    {name: "uniqueCode", type: "hidden", value : "", type2: "hidden"}
];

const initialData_comp = [
    {name: "paraCd", type: "text", value: ""},
    {name: "materialCd", type: "text", value: ""},
    {name: "component", type: "text", value: ""},
    {name: "mainAlter", type: "select", value: "", options: "mainalter"},
	{name: "concentration", type: "text", value: ""},
    {name: "unit1", type: "text", value: "", style:{textAlign: "right"}, borderStyle:{textAlign: "right", borderRight: "none"}},
    {name: "unitseperator", type: "seperator", value: "/", borderStyle:{borderLeft: "none", borderRight: "none", padding: 0, textAlign: "center"}},
    {name: "unit2", type: "text", value: "", borderStyle:{borderLeft: "none"}},
    {name: "reference", type: "text", value: ""},
    {name: "remark", type: "checkbox", value: "FALSE"},
    {name: "uniqueCode", type: "hidden",  value : "",type2: "hidden"}
];

export { initialData_in, initialData_out, initialData_qc, initialData_comp }